<div class="message date-separator" data-isodate="{{{o.isodate}}}">
    <hr class="separator">
    <time class="separator-text" datetime="{{{o.isodate}}}"><span>{{{o.datestring}}}</span></time>
</div>
